<!-- 上传图片 -->
<template>
  <div>
    <b-container>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card-body class="text-center"
            ><h5></h5></b-card-body
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard(1)">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <b-card-img
                  id="myImage_1"
                  src="static/DubaiDIY/科技/公司展会DIY卡-10.png"
                  alt="Image"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col md="12">
              <b-card-body class="text-center">
                <b-button variant="danger" class="btnClass">Apply</b-button>
              </b-card-body>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard(2)">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <b-card-img
                  id="myImage_2"
                  src="static/DubaiDIY/科技/公司展会DIY卡-11.png"
                  alt="Image"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center">
                  <b-button variant="danger" class="btnClass">Apply</b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard(3)">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <b-card-img
                  id="myImage_3"
                  src="static/DubaiDIY/科技/公司展会DIY卡-14.png"
                  alt="Image"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center">
                  <b-button variant="danger" class="btnClass">Apply</b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard(4)">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <b-card-img
                  id="myImage_4"
                  src="static/DubaiDIY/科技/公司展会DIY卡-15.png"
                  alt="Image"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center">
                  <b-button variant="danger" class="btnClass">Apply</b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard(4)">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <b-card-img
                  id="myImage_5"
                  src="static/DubaiDIY/科技/公司展会DIY卡-17.png"
                  alt="Image"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center">
                  <b-button variant="danger" class="btnClass">Apply</b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard(4)">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <b-card-img
                  id="myImage_6"
                  src="static/DubaiDIY/科技/公司展会DIY卡-18.png"
                  alt="Image"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center">
                  <b-button variant="danger" class="btnClass">Apply</b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Select_keji_Dubai",
  data() {
    return {
      name: "",
      mobile: ""
    };
  },
  watch: {},
  methods: {
    toUploadCard(id) {
      var myImage_1 = document.getElementById("myImage_1");
      var myImage_2 = document.getElementById("myImage_2");
      var myImage_3 = document.getElementById("myImage_3");
      var myImage_4 = document.getElementById("myImage_4");
      var myImage_5 = document.getElementById("myImage_5");
      var myImage_6 = document.getElementById("myImage_6");
      var resImg_1 = this.imgToBase64(myImage_1);
      var resImg_2 = this.imgToBase64(myImage_2);
      var resImg_3 = this.imgToBase64(myImage_3);
      var resImg_4 = this.imgToBase64(myImage_4);
      var resImg_5 = this.imgToBase64(myImage_5);
      var resImg_6 = this.imgToBase64(myImage_6);
      if (id == 1) {
        this.toUploadCardface(resImg_1);
      } else if (id == 2) {
        this.toUploadCardface(resImg_2);
      } else if (id == 3) {
        this.toUploadCardface(resImg_3);
      } else if (id == 4) {
        this.toUploadCardface(resImg_4);
      } else if (id == 5) {
        this.toUploadCardface(resImg_5);
      } else if (id == 6) {
        this.toUploadCardface(resImg_6);
      }
    },
    toUploadCardface(img) {
      this.$router.replace({
        name: "UploadCardface_Dubai",
        params: {
          targetImg: img,
          name: this.name,
          mobile: this.mobile
        }
      });
    },
    imgToBase64(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);
      var dataURL = canvas.toDataURL("image/png", 0.8);
      return dataURL;
    }
  },
  mounted: function() {
    this.name = this.$route.query.name;
    this.mobile = this.$route.query.mobile;
  }
};
</script>

<style scoped>
.img {
  width: 100vw;
}

.btnClass {
  font-size: 14px;
  padding-left: 32px;
  padding-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/DubaiCard/Select_keji_Dubai.vue